export enum MovieStatus {
  Unknown = 0,
  Imported = 1,
  Published = 2,
  Archived = 3
}
